import { useState, useEffect } from "react";
import axios from "axios";
import {useParams} from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import {dateHelper } from "../../modules/helpers";
import FileIcon from "../../components/file_icon";
import { userfiles, userfiles_memberUpload } from '../../components/apipath';

function AdmFiles() {
    const {user_type, user_id, tag_id} = useParams();
    const { token } = useAuth();
    const [fileData, setFileData] = useState({
        'resume': [],
        'transcript': [],
        'interview': [],
        'application': [],
        'academic': [],
        'video': [],
        'contract': [],
        'other': [],
    });
    const fileType = ['resume', 'transcript', 'interview', 'video', 'contract', 'application', 'academic', 'other'];
    const [resume, setResume] = useState({
        file_type: 'resume',
        file_name: '',
        file: null,
    });
    const [transcript, setTranscript] = useState({
        file_type: 'transcript',
        file_name: '',
        file: null,
    });
    const [interview, setInterview] = useState({
        file_type: 'interview',
        file_name: '',
        file: null,
    });
    const [video, setVideo] = useState({
        file_type: 'video',
        file_name: '',
        file: null,
    });
    const [contract, setContract] = useState({
        file_type: 'contract',
        file_name: '',
        file: null,
    });
    const [application, setApplication] = useState({
        file_type: 'application',
        file_name: '',
        file: null,
    });
    const [academic, setAcademic] = useState({
        file_type: 'academic',
        file_name: '',
        file: null,
    });
    const [other, setOther] = useState({
        file_type: 'other',
        file_name: '',
        file: null,
    });

    const fetchData = async () => {
        try{
            const response = await axios.get(`${userfiles}${user_type}/${user_id}`, {headers:{token: token}});
            let resume = [];
            let transcript = [];
            let interview = [];
            let contract = [];
            let video = [];
            let application = [];
            let academic = [];
            let other = [];
            
            for (let index in response.data.data){
                if(response.data.data[index].file_type === 'resume'){
                    resume.push(response.data.data[index]);
                } else if(response.data.data[index].file_type === 'transcript'){
                    transcript.push(response.data.data[index]);
                } else if(response.data.data[index].file_type === 'interview'){
                    interview.push(response.data.data[index]);
                } else if(response.data.data[index].file_type === 'video'){
                    video.push(response.data.data[index]);
                } else if(response.data.data[index].file_type === 'contract'){
                    contract.push(response.data.data[index]);
                } else if(response.data.data[index].file_type === 'application'){
                    application.push(response.data.data[index]);
                } else if(response.data.data[index].file_type === 'academic'){
                    academic.push(response.data.data[index]);
                } else if(response.data.data[index].file_type === 'other'){
                    other.push(response.data.data[index]);
                }
            }
            setFileData({
                'resume': resume,
                'transcript': transcript,
                'interview': interview,
                'video': video,
                'contract': contract,
                'application': application,
                'academic': academic,
                'other': other,
            }); 
        } catch(error) {
            console.error(error);
        }
    }

    useEffect(()=>{fetchData()}, []);

    const upload = async(file_type) => {
        try {
            let uploadData = {}
            if(file_type === 'resume'){
                uploadData = {
                    ...resume,
                    user_id: user_id,
                    user_type: user_type
                }
            } else if(file_type === 'transcript'){
                uploadData = {
                    ...transcript,
                    user_id: user_id,
                    user_type: user_type
                }
                
            } else if(file_type === 'interview'){
                uploadData = {
                    ...interview,
                    user_id: user_id,
                    user_type: user_type
                }
            } else if(file_type === 'video'){
                uploadData = {
                    ...video,
                    user_id: user_id,
                    user_type: user_type
                }
            } else if(file_type === 'contract'){
                uploadData = {
                    ...contract,
                    user_id: user_id,
                    user_type: user_type
                }
            } else if(file_type === 'application'){
                uploadData = {
                    ...application,
                    user_id: user_id,
                    user_type: user_type
                }
            } else if(file_type === 'academic'){
                uploadData = {
                    ...academic,
                    user_id: user_id,
                    user_type: user_type
                }
            } else if(file_type === 'other'){
                uploadData = {
                    ...other,
                    user_id: user_id,
                    user_type: user_type
                }
            }
            if (!fileType.includes(uploadData.file_type) || !uploadData.file){
                alert('請選擇檔案!');
                throw new Error('File not exists ot wrong file type.');
            }

            const response = await axios.post(`${userfiles_memberUpload}`, uploadData, {headers:{token: token, "Content-Type": "multipart/form-data"}});
            if (response.data.status !== 200)
                throw new Error(response.data.msg);
            setResume({
                file_type: 'resume',
                file_name: '',
                file: null,
            });
            setTranscript({
                file_type: 'transcript',
                file_name: '',
                file: null,
            });
            setInterview({
                file_type: 'interview',
                file_name: '',
                file: null,
            });
            setVideo({
                file_type: 'video',
                file_name: '',
                file: null,
            });
            setContract({
                file_type: 'contract',
                file_name: '',
                file: null,
            });
            setApplication({
                file_type: 'application',
                file_name: '',
                file: null,
            });
            setAcademic({
                file_type: 'academic',
                file_name: '',
                file: null,
            });
            setOther({
                file_type: 'other',
                file_name: '',
                file: null,
            });
            fetchData();
            document.getElementsByName('resume').forEach((f)=>{ f.value = ''});
            document.getElementsByName('transcript').forEach((f)=>{ f.value = ''});
            document.getElementsByName('interview').forEach((f)=>{ f.value = ''});
            document.getElementsByName('video').forEach((f)=>{ f.value = ''});
            document.getElementsByName('contract').forEach((f)=>{ f.value = ''});
            document.getElementsByName('application').forEach((f)=>{ f.value = ''});
            document.getElementsByName('academic').forEach((f)=>{ f.value = ''});
            document.getElementsByName('other').forEach((f)=>{ f.value = ''});
        } catch (error) {
            console.log(error);
        }
    }

    const handleDelete = async(file_id) => {
        try {
            let confirm = window.confirm("確認刪除 ?");
            if(confirm){
                const response = await axios.delete(`${userfiles}${file_id}`, {headers:{token: token}});
                if(response.data.status !== 200)
                    throw new Error(response.data.msg);
                fetchData();
            }
        } catch (error) {
            alert('刪除失敗，請見 Log')
            console.log(error);
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'resume'){
            setResume({
                ...resume,
                file_name: value,
                file: e.target.files[0] ?? null,
            })
        } else if (name === 'transcript'){
            setTranscript({
                ...transcript,
                file_name: value,
                file: e.target.files[0] ?? null,
            })
        } else if (name === 'interview'){
            setInterview({
                ...interview,
                file_name: value,
                file: e.target.files[0] ?? null,
            })
        } else if (name === 'video'){
            setVideo({
                ...video,
                file_name: value,
                file: e.target.files[0] ?? null,
            })
        } else if (name === 'contract'){
            setContract({
                ...contract,
                file_name: value,
                file: e.target.files[0] ?? null,
            })
        } else if (name === 'application'){
            setApplication({
                ...application,
                file_name: value,
                file: e.target.files[0] ?? null,
            })
        } else if (name === 'academic'){
            setAcademic({
                ...academic,
                file_name: value,
                file: e.target.files[0] ?? null,
            })
        } else if (name === 'other'){
            setOther({
                ...other,
                file_name: value,
                file: e.target.files[0] ?? null,
            })
        } 
        /*
        if (['checkbox'].includes(type)){
            setMemberData({
                ...memberData,
                [name]: switchHelper(checked),
            });
        } else {
            setMemberData({
                ...memberData,
                [name]: value,
            });
        }
        */
    }

    useEffect(()=>{
        const targetScroll = document.getElementById(tag_id);
        if(targetScroll) targetScroll.scrollIntoView(true, {block: "start", inline: "nearest"});
    }, []);


    if (user_type === 'member'){
        return (
            <>
                <div className="container" style={{marginTop:"50px"}}>
                    <div className="row g-5">
                        <div className="col-12">
                            <div className="card" id="mResume">
                                <div className="card-header bg-success text-light">
                                    <div className="card-title">
                                        <h4 className="p-0 m-0">履歷</h4>
                                    </div>
                                    
                                </div>
                                <div className="card-body table-responsive">
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text">新增檔案</span>
                                        <input type="file" name="resume" className="form-control form-control-sm" onChange={handleInputChange} />
                                        <button className="btn btn-sm btn-primary" onClick={()=>{upload('resume')}}>上傳</button>
                                    </div>
                                    <hr/>
                                    <table className="table table-borderless table-striped table-hover">
                                        <thead>
                                            <tr className="text-center">
                                                <th scope="col">名稱</th>
                                                <th scope="col">大小</th>
                                                <th scope="col">上傳日期</th>
                                                <th scope="col">上傳者</th>
                                                <th scope="col">操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fileData && fileData.resume.map((file)=>{
                                                return (
                                                <tr key={file.id}>
                                                    <td>
                                                        <div className="text-nowrap">
                                                            {FileIcon(file.file_extension)}    
                                                            <a target="_blank" href={file.file_url} rel="noreferrer" className="btn btn-sm btn-outline-primary">{file.file_name}</a>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">{`${Math.round((file.file_size / 1024.0 / 1024.0 * 100)) / 100.0} MB`}</td>
                                                    <td className="text-center">{dateHelper(file.file_date, 'datetime')}</td>
                                                    <td className="text-center">{(file.upload_person + "").split('|')[1]}</td>
                                                    <td className="text-center"><button className="btn btn-sm btn-danger" onClick={()=>{
                                                        handleDelete(file.id);
                                                    }}>刪除</button></td>
                                                </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="card" id="mTranscript">
                                <div className="card-header bg-warning">
                                    <div className="card-title">
                                        <h4 className="p-0 m-0">成績單</h4>
                                    </div>
                                    
                                </div>
                                <div className="card-body table-responsive">
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text">新增檔案</span>
                                        <input type="file" name="transcript" className="form-control form-control-sm" onChange={handleInputChange} />
                                        <button className="btn btn-sm btn-primary" onClick={()=>{upload('transcript')}}>上傳</button>
                                    </div>
                                    <hr/>
                                    <table className="table table-borderless table-striped table-hover">
                                        <thead>
                                            <tr className="text-center">
                                                <th scope="col">名稱</th>
                                                <th scope="col">大小</th>
                                                <th scope="col">上傳日期</th>
                                                <th scope="col">上傳者</th>
                                                <th scope="col">操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fileData && fileData.transcript.map((file)=>{
                                                return (
                                                <tr key={file.id}>
                                                    <td>
                                                        <div className="text-nowrap">
                                                            {FileIcon(file.file_extension)}    
                                                            <a target="_blank" href={file.file_url} rel="noreferrer" className="btn btn-sm btn-outline-primary">{file.file_name}</a>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">{`${Math.round((file.file_size / 1024.0 / 1024.0 * 100)) / 100.0} MB`}</td>
                                                    <td className="text-center">{dateHelper(file.file_date, 'datetime')}</td>
                                                    <td className="text-center">{(file.upload_person + "").split('|')[1]}</td>
                                                    <td className="text-center"><button className="btn btn-sm btn-danger" onClick={()=>{
                                                        handleDelete(file.id);
                                                    }}>刪除</button></td>
                                                </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="card" id="mInterview">
                                <div className="card-header bg-info">
                                    <div className="card-title">
                                        <h4 className="p-0 m-0">諮詢紀錄</h4>
                                    </div>
                                    
                                </div>
                                <div className="card-body table-responsive">
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text">新增檔案</span>
                                        <input type="file" name="interview" className="form-control form-control-sm" onChange={handleInputChange} />
                                        <button className="btn btn-sm btn-primary" onClick={()=>{upload('interview')}}>上傳</button>
                                    </div>
                                    <hr/>
                                    <table className="table table-borderless table-striped table-hover">
                                        <thead>
                                            <tr className="text-center">
                                                <th scope="col">名稱</th>
                                                <th scope="col">大小</th>
                                                <th scope="col">上傳日期</th>
                                                <th scope="col">上傳者</th>
                                                <th scope="col">操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fileData && fileData.interview.map((file)=>{
                                                return (
                                                <tr key={file.id}>
                                                    <td>
                                                        <div className="text-nowrap">
                                                            {FileIcon(file.file_extension)}    
                                                            <a target="_blank" href={file.file_url} rel="noreferrer" className="btn btn-sm btn-outline-primary">{file.file_name}</a>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">{`${Math.round((file.file_size / 1024.0 / 1024.0 * 100)) / 100.0} MB`}</td>
                                                    <td className="text-center">{dateHelper(file.file_date, 'datetime')}</td>
                                                    <td className="text-center">{(file.upload_person + "").split('|')[1]}</td>
                                                    <td className="text-center"><button className="btn btn-sm btn-danger" onClick={()=>{
                                                        handleDelete(file.id);
                                                    }}>刪除</button></td>
                                                </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="card" id="mApplication">
                                <div className="card-header bg-primary text-light">
                                    <div className="card-title">
                                        <h4 className="p-0 m-0">報考文件</h4>
                                    </div>
                                    
                                </div>
                                <div className="card-body table-responsive">
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text">新增檔案</span>
                                        <input type="file" name="application" className="form-control form-control-sm" onChange={handleInputChange} />
                                        <button className="btn btn-sm btn-primary" onClick={()=>{upload('application')}}>上傳</button>
                                    </div>
                                    <hr/>
                                    <table className="table table-borderless table-striped table-hover">
                                        <thead>
                                            <tr className="text-center">
                                                <th scope="col">名稱</th>
                                                <th scope="col">大小</th>
                                                <th scope="col">上傳日期</th>
                                                <th scope="col">上傳者</th>
                                                <th scope="col">操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fileData && fileData.application.map((file)=>{
                                                return (
                                                <tr key={file.id}>
                                                    <td>
                                                        <div className="text-nowrap">
                                                            {FileIcon(file.file_extension)}    
                                                            <a target="_blank" href={file.file_url} rel="noreferrer" className="btn btn-sm btn-outline-primary">{file.file_name}</a>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">{`${Math.round((file.file_size / 1024.0 / 1024.0 * 100)) / 100.0} MB`}</td>
                                                    <td className="text-center">{dateHelper(file.file_date, 'datetime')}</td>
                                                    <td className="text-center">{(file.upload_person + "").split('|')[1]}</td>
                                                    <td className="text-center"><button className="btn btn-sm btn-danger" onClick={()=>{
                                                        handleDelete(file.id);
                                                    }}>刪除</button></td>
                                                </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="card" id="mAcademic">
                                <div className="card-header bg-secondary text-light">
                                    <div className="card-title">
                                        <h4 className="p-0 m-0">學歷認證</h4>
                                    </div>
                                    
                                </div>
                                <div className="card-body table-responsive">
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text">新增檔案</span>
                                        <input type="file" name="academic" className="form-control form-control-sm" onChange={handleInputChange} />
                                        <button className="btn btn-sm btn-primary" onClick={()=>{upload('academic')}}>上傳</button>
                                    </div>
                                    <hr/>
                                    <table className="table table-borderless table-striped table-hover">
                                        <thead>
                                            <tr className="text-center">
                                                <th scope="col">名稱</th>
                                                <th scope="col">大小</th>
                                                <th scope="col">上傳日期</th>
                                                <th scope="col">上傳者</th>
                                                <th scope="col">操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fileData && fileData.academic.map((file)=>{
                                                return (
                                                <tr key={file.id}>
                                                    <td>
                                                        <div className="text-nowrap">
                                                            {FileIcon(file.file_extension)}    
                                                            <a target="_blank" href={file.file_url} rel="noreferrer" className="btn btn-sm btn-outline-primary">{file.file_name}</a>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">{`${Math.round((file.file_size / 1024.0 / 1024.0 * 100)) / 100.0} MB`}</td>
                                                    <td className="text-center">{dateHelper(file.file_date, 'datetime')}</td>
                                                    <td className="text-center">{(file.upload_person + "").split('|')[1]}</td>
                                                    <td className="text-center"><button className="btn btn-sm btn-danger" onClick={()=>{
                                                        handleDelete(file.id);
                                                    }}>刪除</button></td>
                                                </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="card" id="mOther">
                                <div className="card-header">
                                    <div className="card-title">
                                        <h4 className="p-0 m-0">其他</h4>
                                    </div>
                                    
                                </div>
                                <div className="card-body table-responsive">
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text">新增檔案</span>
                                        <input type="file" name="other" className="form-control form-control-sm" onChange={handleInputChange} />
                                        <button className="btn btn-sm btn-primary" onClick={()=>{upload('other')}}>上傳</button>
                                    </div>
                                    <hr/>
                                    <table className="table table-borderless table-striped table-hover">
                                        <thead>
                                            <tr className="text-center">
                                                <th scope="col">名稱</th>
                                                <th scope="col">大小</th>
                                                <th scope="col">上傳日期</th>
                                                <th scope="col">上傳者</th>
                                                <th scope="col">操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fileData && fileData.other.map((file)=>{
                                                return (
                                                <tr key={file.id}>
                                                    <td>
                                                        <div className="text-nowrap">
                                                            {FileIcon(file.file_extension)}    
                                                            <a target="_blank" href={file.file_url} rel="noreferrer" className="btn btn-sm btn-outline-primary">{file.file_name}</a>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">{`${Math.round((file.file_size / 1024.0 / 1024.0 * 100)) / 100.0} MB`}</td>
                                                    <td className="text-center">{dateHelper(file.file_date, 'datetime')}</td>
                                                    <td className="text-center">{(file.upload_person + "").split('|')[1]}</td>
                                                    <td className="text-center"><button className="btn btn-sm btn-danger" onClick={()=>{
                                                        handleDelete(file.id);
                                                    }}>刪除</button></td>
                                                </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </>
        );
    } else if (user_type === 'teacher'){
        return (
            <>
                <div className="container" style={{marginTop:"50px"}}>
                    <div className="row g-5">
                        <div className="col-12">
                            <div className="card" id="tResume">
                                <div className="card-header bg-success text-light">
                                    <div className="card-title">
                                        <h4 className="p-0 m-0">履歷</h4>
                                    </div>
                                    
                                </div>
                                <div className="card-body table-responsive">
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text">新增檔案</span>
                                        <input type="file" name="resume" className="form-control form-control-sm" onChange={handleInputChange} />
                                        <button className="btn btn-sm btn-primary" onClick={()=>{upload('resume')}}>上傳</button>
                                    </div>
                                    <hr/>
                                    <table className="table table-borderless table-striped table-hover">
                                        <thead>
                                            <tr className="text-center">
                                                <th scope="col">名稱</th>
                                                <th scope="col">大小</th>
                                                <th scope="col">上傳日期</th>
                                                <th scope="col">上傳者</th>
                                                <th scope="col">操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fileData && fileData.resume.map((file)=>{
                                                return (
                                                <tr key={file.id}>
                                                    <td>
                                                        <div className="text-nowrap">
                                                            {FileIcon(file.file_extension)}    
                                                            <a target="_blank" href={file.file_url} rel="noreferrer" className="btn btn-sm btn-outline-primary">{file.file_name}</a>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">{`${Math.round((file.file_size / 1024.0 / 1024.0 * 100)) / 100.0} MB`}</td>
                                                    <td className="text-center">{dateHelper(file.file_date, 'datetime')}</td>
                                                    <td className="text-center">{(file.upload_person + "").split('|')[1]}</td>
                                                    <td className="text-center"><button className="btn btn-sm btn-danger" onClick={()=>{
                                                        handleDelete(file.id);
                                                    }}>刪除</button></td>
                                                </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="card" id="tVideo">
                                <div className="card-header bg-warning">
                                    <div className="card-title">
                                        <h4 className="p-0 m-0">試教影片</h4>
                                    </div>
                                    
                                </div>
                                <div className="card-body table-responsive">
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text">新增檔案</span>
                                        <input type="file" name="video" className="form-control form-control-sm" onChange={handleInputChange} />
                                        <button className="btn btn-sm btn-primary" onClick={()=>{upload('video')}}>上傳</button>
                                    </div>
                                    <hr/>
                                    <table className="table table-borderless table-striped table-hover">
                                        <thead>
                                            <tr className="text-center">
                                                <th scope="col">名稱</th>
                                                <th scope="col">大小</th>
                                                <th scope="col">上傳日期</th>
                                                <th scope="col">上傳者</th>
                                                <th scope="col">操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fileData && fileData.video.map((file)=>{
                                                return (
                                                <tr key={file.id}>
                                                    <td>
                                                        <div className="text-nowrap">
                                                            {FileIcon(file.file_extension)}    
                                                            <a target="_blank" href={file.file_url} rel="noreferrer" className="btn btn-sm btn-outline-primary">{file.file_name}</a>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">{`${Math.round((file.file_size / 1024.0 / 1024.0 * 100)) / 100.0} MB`}</td>
                                                    <td className="text-center">{dateHelper(file.file_date, 'datetime')}</td>
                                                    <td className="text-center">{(file.upload_person + "").split('|')[1]}</td>
                                                    <td className="text-center"><button className="btn btn-sm btn-danger" onClick={()=>{
                                                        handleDelete(file.id);
                                                    }}>刪除</button></td>
                                                </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="card" id="tContract">
                                <div className="card-header bg-info">
                                    <div className="card-title">
                                        <h4 className="p-0 m-0">合約</h4>
                                    </div>
                                    
                                </div>
                                <div className="card-body table-responsive">
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text">新增檔案</span>
                                        <input type="file" name="contract" className="form-control form-control-sm" onChange={handleInputChange} />
                                        <button className="btn btn-sm btn-primary" onClick={()=>{upload('contract')}}>上傳</button>
                                    </div>
                                    <hr/>
                                    <table className="table table-borderless table-striped table-hover">
                                        <thead>
                                            <tr className="text-center">
                                                <th scope="col">名稱</th>
                                                <th scope="col">大小</th>
                                                <th scope="col">上傳日期</th>
                                                <th scope="col">上傳者</th>
                                                <th scope="col">操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fileData && fileData.contract.map((file)=>{
                                                return (
                                                <tr key={file.id}>
                                                    <td>
                                                        <div className="text-nowrap">
                                                            {FileIcon(file.file_extension)}    
                                                            <a target="_blank" href={file.file_url} rel="noreferrer" className="btn btn-sm btn-outline-primary">{file.file_name}</a>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">{`${Math.round((file.file_size / 1024.0 / 1024.0 * 100)) / 100.0} MB`}</td>
                                                    <td className="text-center">{dateHelper(file.file_date, 'datetime')}</td>
                                                    <td className="text-center">{(file.upload_person + "").split('|')[1]}</td>
                                                    <td className="text-center"><button className="btn btn-sm btn-danger" onClick={()=>{
                                                        handleDelete(file.id);
                                                    }}>刪除</button></td>
                                                </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="card" id="tOther">
                                <div className="card-header">
                                    <div className="card-title">
                                        <h4 className="p-0 m-0">其他</h4>
                                    </div>
                                    
                                </div>
                                <div className="card-body table-responsive">
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text">新增檔案</span>
                                        <input type="file" name="other" className="form-control form-control-sm" onChange={handleInputChange} />
                                        <button className="btn btn-sm btn-primary" onClick={()=>{upload('other')}}>上傳</button>
                                    </div>
                                    <hr/>
                                    <table className="table table-borderless table-striped table-hover">
                                        <thead>
                                            <tr className="text-center">
                                                <th scope="col">名稱</th>
                                                <th scope="col">大小</th>
                                                <th scope="col">上傳日期</th>
                                                <th scope="col">上傳者</th>
                                                <th scope="col">操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fileData && fileData.other.map((file)=>{
                                                return (
                                                <tr key={file.id}>
                                                    <td>
                                                        <div className="text-nowrap">
                                                            {FileIcon(file.file_extension)}    
                                                            <a target="_blank" href={file.file_url} rel="noreferrer" className="btn btn-sm btn-outline-primary">{file.file_name}</a>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">{`${Math.round((file.file_size / 1024.0 / 1024.0 * 100)) / 100.0} MB`}</td>
                                                    <td className="text-center">{dateHelper(file.file_date, 'datetime')}</td>
                                                    <td className="text-center">{(file.upload_person + "").split('|')[1]}</td>
                                                    <td className="text-center"><button className="btn btn-sm btn-danger" onClick={()=>{
                                                        handleDelete(file.id);
                                                    }}>刪除</button></td>
                                                </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </>
        );
    }
}
export default AdmFiles;